const initial_state = {
  //progress count
  total_poi: 1,
  current_progress_poi: 0,
  total_demo: 100,
  current_progress_demo: 0,
  total_grid_group: 1,
  current_grid_group: 0,
  total_formula: 100,
  current_formula: 0,
  total_save_feature: 100,
  current_save_feature: 0,
  step_ss: 0,

  //search
  kelurahan_list_by_search: [],
  kecamatan_list_by_search: [],
  kota_list_by_search: [],

  //value selected
  provinsi: "",
  kota: "",
  kecamatan: "",
  desa: "",

  //hirarki
  kelurahan_hirarki: [],
  kecamatan_hirarki: [],
  kota_hirarki: [],
  provinsi_hirarki: [],

  //data raw
  features_demography: [],
  features_poi: [],

  //data sementara
  auto_step: 0, //0 || 1 || 2 || 3
  mode_input_parent: "", // "" || "simple" || "custom"
  is_estimated: false,
  features_grid_raw: [],
  features_grid: [],
  features_grid_filtered: [],
  features_centroid_sample: [],
  features_grid_saved: [],
  value_array_filter: [],
  grid_mode: "square", //square || hex
  grid_size_mode: "width", //count, width
  grid_counts: 200,
  grid_counts_approx: 200,
  grid_width_meters: 1000,
  grid_width_meters_approx: 1000,
  total_square_meters: 0,
  total_poi_initial: 0,

  //miscellaneous
  top_result_limit: 10,
  demography_group_selected: "all",
  sidebar_content: "home", //home || formula || result
  step_formula: 0,
  insight_update: 0,
  insight_fly_update: 0,
  menu_formula: "manual", //manual || template || AI
  is_show_formula: false,
  site_selection_view: "input", //input || report || edit
  map_object_ss: null,
  legend_site_selection: false,

  //site selection parameters
  tipe_level: "tipe_1", //tipe_1 || tipe_2 || tipe_3
  tipe_1_array: [], //array of object
  tipe_2_array: [], //array of object
  tipe_3_array: [], //array of object
  tipe_1_all: false,
  list_tipe_1: [],
  list_tipe_2: [],
  list_tipe_3: [],
  feature_sample: undefined,
  list_tipe_2_properti: [],
  is_allow_save: false,
  is_show_top_result: false,
  modal_ss_done: false,

  //formula config
  array_formula_insight: [],
  array_group_insight: [
    {
      key: "poi",
      key_raw: "poi_raw",
      is_directly_proportional: true,
      min: 0,
      max: 100,
      weight_score: 1,
    },
    {
      key: "demography",
      key_raw: "demography_raw",
      is_directly_proportional: true,
      min: 0,
      max: 100,
      weight_score: 1,
    },
  ],
  config_final_score: {
    min: 0,
    max: 100,
  },

  //formula saved
  formula_mapid_list: [],
  formula_user_list: [],
  formula_name: "",
  formula_desc: "",
  formula_selected: {},
  formula_selected_run: {},
  modal_run_template: false,
  prompt_ss: "",
  response_ai_poi: "",
  response_ai_demo: "",
  //error handling
  error_object_area: {},
  modal_error_area: false,
  error_object_poi: {},
  modal_error_poi: false,
};

export default function insight_reducer(state = initial_state, action) {
  switch (action.type) {
    case "insight_update":
      return {
        ...state,
        insight_update: state.insight_update + 1,
      };
    case "insight_fly_update":
      return {
        ...state,
        insight_fly_update: state.insight_fly_update + 1,
      };
    case "set_value_insight":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "push_value_insight":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };
    case "push_value_many_insight":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          [...action.payload.value],
        ],
      };
    default:
      return state;
  }
}
